import { ArrowCircleUpRight } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import type { ToggleProps } from 'src/v2/commonComponents/DrawerTooltipContainer';
import styles from './MoveToEditorToggle.module.scss';
import { ArtifactType } from 'src/types';
import { useGetUser } from 'src/hooks';

interface MoveToEditorToggleProps extends ToggleProps {
  componentType?: ArtifactType;
}

export const MoveToEditorToggle = ({
  id,
  disabled,
  isActive,
  componentType,
  onClick,
}: MoveToEditorToggleProps) => {
  const { isOpenTier } = useGetUser();
  const isDocument = componentType === ArtifactType.TEXT;

  if (isDocument) {
    return (
      <div id={id}>
        <Button
          disabled={disabled || isOpenTier}
          color={isActive ? 'tertiary' : 'secondary-outline'}
          onClick={onClick}
          tooltipContent={
            isOpenTier
              ? 'Available with subscription'
              : 'Send to editor to refine and edit content'
          }
          tooltipPlace="top"
        >
          <ArrowCircleUpRight weight="fill" size={SVG_SIZE_M} />
          Editor
        </Button>
      </div>
    );
  }

  return (
    <div id={id}>
      <Button
        disabled={disabled || isOpenTier}
        color={isActive ? 'tertiary' : 'link'}
        shape="round"
        size="small"
        onClick={onClick}
        className={styles.root}
        tooltipContent={
          isOpenTier ? 'Available with subscription' : 'Send to Editor'
        }
        tooltipPlace="right"
      >
        <ArrowCircleUpRight weight="fill" size={SVG_SIZE_M} />
      </Button>
    </div>
  );
};
